import { Injectable, Signal, computed, inject } from '@angular/core';
import { PolicyService } from '../../process';

@Injectable({
  providedIn: 'root'
})
export class CardLeadFacade {
  readonly isCardLeadFormPresented$$: Signal<boolean> = computed(() => {
    const leadConfig = this._policyService.findFeatureConfig$$('lead');
    return leadConfig()?.indication['isLeadFormPresented'];
  });
  private _policyService = inject(PolicyService);

  constructor() {}
}
